
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

window.requestAnimationFrame =
		window.requestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); },
			                           timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};

window.cancelAnimationFrame =
		window.cancelAnimationFrame ||
		window.mozCancelRequestAnimationFrame ||
		window.webkitCancelRequestAnimationFrame ||
		window.msCancelRequestAnimationFrame ||
		window.oCancelRequestAnimationFrame ||
		function(id) {
			clearTimeout(id);
		};

